export { default } from './InstallationSection';
